"use strict";

angular.module('PatientApp').factory('NotificationsService', function (VuexStore) {
  return {
    setSeen: function setSeen() {
      VuexStore.dispatch('setNotificationsSeen');
    },
    hasNewNotifications: function hasNewNotifications() {
      return VuexStore.state.NotificationsStore.numNew > 0;
    },
    getNumberOfNewNotifications: function getNumberOfNewNotifications() {
      return VuexStore.state.NotificationsStore.numNew;
    },
    fetchNotifications: function fetchNotifications() {
      return VuexStore.dispatch('fetchNotifications');
    },
    getNotifications: function getNotifications(forceFetch) {
      return VuexStore.dispatch('getNotifications', forceFetch);
    },
    updateNotificationReadLog: function updateNotificationReadLog(id, isRead) {
      return VuexStore.dispatch('updateNotificationReadLog', {
        notificationId: id,
        isRead: isRead
      });
    },
    updateNotificationClickLog: function updateNotificationClickLog(id) {
      return VuexStore.dispatch('updateNotificationClickLog', {
        notificationId: id
      });
    }
  };
});